(() => {
  const setup = (section) => {
    if (section.dataset.videoReviewsReady === 'true') return;
    section.dataset.videoReviewsReady = 'true';

    const track = section.querySelector('[data-video-track]');
    const slides = [...section.querySelectorAll('[data-video-slide]')];
    const dots = [...section.querySelectorAll('[data-video-dot]')];
    const previous = section.querySelector('[data-video-previous]');
    const next = section.querySelector('[data-video-next]');
    if (!track || !slides.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const speed = Number.parseInt(getComputedStyle(section).getPropertyValue('--video-reviews-speed'), 10) || 5000;
    let activeIndex = 0;
    let timer;
    let inView = false;
    let frame;

    const closestIndex = () => {
      const left = track.getBoundingClientRect().left;
      let best = 0;
      let distance = Infinity;
      slides.forEach((slide, index) => {
        const currentDistance = Math.abs(slide.getBoundingClientRect().left - left);
        if (currentDistance < distance) {
          best = index;
          distance = currentDistance;
        }
      });
      return best;
    };
    const playActiveVideo = () => {
      slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (inView && !reducedMotion && index === activeIndex && document.visibilityState === 'visible') {
          if (video.paused) video.play().catch(() => {});
        }
        else video.pause();
      });
    };
    const update = () => {
      frame = undefined;
      if (!inView) return;
      activeIndex = closestIndex();
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === activeIndex)));
      if (previous) previous.disabled = atStart;
      if (next) next.disabled = atEnd;
      playActiveVideo();
    };
    const scheduleUpdate = () => {
      if (inView && frame === undefined) frame = requestAnimationFrame(update);
    };
    const goTo = (index) => {
      const target = Math.max(0, Math.min(index, slides.length - 1));
      const trackLeft = track.getBoundingClientRect().left;
      const slideLeft = slides[target].getBoundingClientRect().left;
      track.scrollTo({
        left: track.scrollLeft + slideLeft - trackLeft,
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
    };
    const restart = () => {
      clearInterval(timer);
      if (!inView || document.hidden || section.dataset.autoplay !== 'true' || reducedMotion || slides.length < 2) return;
      timer = setInterval(() => goTo(activeIndex >= slides.length - 1 || next?.disabled ? 0 : activeIndex + 1), speed);
    };

    previous?.addEventListener('click', () => { goTo(activeIndex - 1); restart(); });
    next?.addEventListener('click', () => { goTo(activeIndex + 1); restart(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { goTo(index); restart(); }));
    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    section.addEventListener('mouseenter', () => clearInterval(timer));
    section.addEventListener('mouseleave', restart);
    section.addEventListener('focusin', () => clearInterval(timer));
    section.addEventListener('focusout', restart);
    const visibilityChanged = () => { playActiveVideo(); restart(); };
    document.addEventListener('visibilitychange', visibilityChanged);
    const intersectionObserver = new IntersectionObserver(([entry]) => {
      inView = entry.isIntersecting;
      scheduleUpdate();
      playActiveVideo();
      restart();
    }, { threshold: .2 });
    intersectionObserver.observe(section);
    const resizeObserver = new ResizeObserver(scheduleUpdate);
    resizeObserver.observe(track);
    const unload = (event) => {
      if (!event.target.contains(section)) return;
      clearInterval(timer);
      cancelAnimationFrame(frame);
      intersectionObserver.disconnect();
      resizeObserver.disconnect();
      document.removeEventListener('visibilitychange', visibilityChanged);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  };

  document.querySelectorAll('[data-video-reviews]').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('[data-video-reviews]');
    if (section) setup(section);
  });
})();
